// extracted by mini-css-extract-plugin
export var bubble = "_4a-0";
export var container = "_4a-f";
export var contrastBorder = "_4a-g";
export var greyOut = "_4a-2";
export var initialsColor0 = "_4a-3";
export var initialsColor1 = "_4a-4";
export var initialsColor10 = "_4a-d";
export var initialsColor11 = "_4a-e";
export var initialsColor2 = "_4a-5";
export var initialsColor3 = "_4a-6";
export var initialsColor4 = "_4a-7";
export var initialsColor5 = "_4a-8";
export var initialsColor6 = "_4a-9";
export var initialsColor7 = "_4a-a";
export var initialsColor8 = "_4a-b";
export var initialsColor9 = "_4a-c";
export var initialsWrapper = "_4a-1";
export var large = "_4a-l";
export var medium = "_4a-k";
export var mediumSmall = "_4a-j";
export var mediumSmallMedium = "_4a-o";
export var micro = "_4a-h";
export var small = "_4a-i";
export var tiny = "_4a-n";
export var xTiny = "_4a-m";